import React, { useState, Fragment } from 'react'
import { Highlighter } from 'react-bootstrap-typeahead'
import TypeaheadInput from 'components/TypeaheadInput'
import './style.scss'

const SelectProvider = props => {
  const [state, setState] = useState(() => {
    return {
      ...props
    }
  })

  const onChange = value => {
    const selected = state.options.find(item => item.value === value)

    if (selected) {
      setState(() => ({ ...props, selected: selected.value }))
      var customEvent = new CustomEvent('typeahead-select:change', {
        detail: selected
      })
      window.dispatchEvent(customEvent)
    }
  }

  const renderMenuItemChildren = (option, props) => {
    return (
      <Fragment>
        <span className='me-3 my-auto'>
          <Highlighter search={props.text}>{option.label}</Highlighter>
        </span>
        <div className='mt-1'>
          {option.type === 'internal' && (
            <div className='mt-1 mustard-color'>
              (No service auth required)
            </div>
          )}
        </div>
      </Fragment>
    )
  }

  return (
    <>
      <div className={`input required  select-service-definition ${state.errors ? 'error' : null} `} id='provider_id_input'>
        <label className={`label mb-2`}>
          Which provider? <abbr title='required'>*</abbr>
        </label>
        <br />
        <div className='org-typeahead'>
          <TypeaheadInput {...state} onChange={onChange} renderMenuItemChildren={renderMenuItemChildren} />
        </div>
      </div>
    </>
  )
}

export default SelectProvider
